import { PRICE_MULTIPLIERS } from './constants';

export function applyPriceMultiplier(basePrice, priceTier) {
  if (!basePrice || !priceTier) return basePrice;
  return basePrice * (PRICE_MULTIPLIERS[priceTier] ?? 1.0);
}

export function getSavingsLabel(priceTier) {
  const mult = PRICE_MULTIPLIERS[priceTier] ?? 1;
  const pct = Math.round(Math.abs(1 - mult) * 100);
  if (pct === 0) return null;
  return { text: mult < 1 ? `-${pct}%` : `+${pct}%`, saving: mult < 1 };
}

export function normStr(str) {
  return (str || "").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function findBestMatch(name, ingredients) {
  const normalized = normStr(name);
  for (const ing of ingredients) {
    const ingName = normStr(ing.name);
    if (ingName === normalized) return ing;
  }
  for (const ing of ingredients) {
    const ingName = normStr(ing.name);
    if (ingName.includes(normalized) || normalized.includes(ingName)) return ing;
  }
  return null;
}
